export default __webpack_public_path__ + "locales/sk/MainBar.json?hash=59f72275a41b8f1240d6788075cc4e03";